import React, {FunctionComponent, useCallback, useState, useEffect} from "react";
import {useDropzone} from "react-dropzone";
import {useSnackbar} from "notistack";
import {ReactComponent as CameraBackGround} from "../../assets/camera.svg";
import {ReactComponent as Cross} from "../../assets/cross.svg";
import {Card, CardMedia, IconButton} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import {ReactComponent as PlayCircle} from "../../assets/PlayCircleWhite.svg";
import {useSelector} from "react-redux";
import {RootState} from "../../redux/store";

interface Props {
    onLoad?: any,
    deletePhoto?: any,
    photo?: any,
    type?: string,
    sizeLimit?: boolean,
}

const useStyles = makeStyles({
    dropZoneContainer: {
        position: "relative",
        width: 133,
        height: 133,
        background: "#FFFFF",
        border: "1px solid #CCCDE5",
        boxSizing: "border-box",
        borderRadius: 6,
        overflow: "hidden",
        cursor: "pointer"
    },
    cameraBackground: {
        position: "absolute",
        left: 40,
        top: 40
    },
    crossContainer: {
        cursor: "pointer",
        zIndex: 11,
        backgroundColor: "#fff",
        borderRadius: 50,
        height: "16px",
        width: "16px",
        position: "absolute",
        right: 5,
        top: 5,
        textAlign: "center",
    },
    cross: {
        cursor: "pointer",
        zIndex: 12,
    },
    videoBtnMob: {
        color: "#000",
        width: "2em",
        height: "2em",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        fontSize: "2em"
    }
}
);

export const DropZone: FunctionComponent<Props> = ({onLoad, photo, type = "img", deletePhoto, sizeLimit = true}: Props) => {
    const classes = useStyles();
    const [img, setImage] = useState(null);
    const [file, setFile] = useState(null);
    const {enqueueSnackbar} = useSnackbar();
    useEffect(() => {
        if (file) {
            setImage(file);
        }
        else {
            setImage(null);
            setFile(null);
        }
    }, []);

    useEffect(() => {
        if (photo) {
            setImage(photo);
        }
        else {
            setImage(null);
            setFile(null);
        }
    }, [photo]);
    const onDrop = useCallback((acceptedFiles) => {
        acceptedFiles.forEach((file) => {
            const reader = new FileReader();
            if ((type === "img" && (file.type === "image/jpeg" || file.type === "image/png")) || (type === "video" && (file.type === "video/mp4" || file.type === "video/quicktime"))) {
                if (sizeLimit && type === "img") {
                    if (file.size < 5000000) {
                        reader.onload = () => {
                            onLoad(reader.result);
                            setFile(reader.result);
                        };
                    }
                    else enqueueSnackbar("The selected image exceeds the size limit. Please select a different image or reduce this image's size", {variant: "error", autoHideDuration: 3000});
                }
                else {
                    reader.onload = () => {
                        onLoad(reader.result);
                        setFile(reader.result);
                    };
                }
            }
            else enqueueSnackbar(`Please upload ${type === "img" ? "JPG or PNG" : "mp4/mov video"} format`, {variant: "error", autoHideDuration: 3000});
            reader.readAsDataURL(file);
        });
    }, []);

    const {getRootProps, getInputProps} = useDropzone({onDrop});
    return (
        <div className={classes.dropZoneContainer}>
            <div {...getRootProps()} style={{zIndex: 10, width: 133, height: 133, position: "absolute"}}>
                <input {...getInputProps()} />
            </div>
            {photo && <div className={classes.crossContainer} onClick={deletePhoto}>
                <Cross className={classes.cross}/>
            </div>}
            {
                file || photo ?
                    <Card>
                        <CardMedia
                            // @ts-ignore
                            component={(file?.substr(4, 20).includes("video") || photo?.substr(4, 20).includes("video")) ? "img" : type}
                            alt="Contemplative Reptile"
                            height="130"
                            src={img}
                            title="Contemplative Reptile"
                        />
                        { (file?.substr(4, 20).includes("video") || photo?.substr(4, 20).includes("video")) &&
                            <IconButton aria-label="add an alarm" className={classes.videoBtnMob}>
                                <PlayCircle
                                    style={{
                                        width: "2em",
                                        height: "2em",
                                    }}
                                />
                            </IconButton>}
                    </Card> : <CameraBackGround className={classes.cameraBackground}/>
            }
        </div>
    );
};
